import { makeStyles } from "@material-ui/core/styles"

export const usePaperStyles = makeStyles({
  paper: {
    maxHeight: "30rem",
  },
})
